<div class="row">
    <div class="col-1">
        <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;width:300px;" (click)="onSubmitParkersReadyForActivation()">Find Non spACE Accounts</button>
    </div>    
</div>


<ng-container *ngIf="this.queryPerformed == false">
    <div style="margin-top:20px;margin-left:10px;height:30px;">
        <span style="font-size:larger;font-weight:400">Click Above to Find Non spACE Accounts for Lot {{lotDisplayName}}</span>
    </div>
</ng-container>



<ng-container *ngIf="this.parkerActivationList.length === 0 && this.queryPerformed == true">
    <div style="margin-top:20px;margin-left:10px;height:30px;">
        <span style="font-size:larger;font-weight:400">No Parkers found for this Lot Number</span>
    </div>
</ng-container>



<ng-container *ngIf="this.parkerActivationList.length > 0 && this.isProcessingNewUsers === true">
    <div class="row">
        <div class="col-1">
            <mat-spinner style="height:30px;width:50px"></mat-spinner>
        </div>
        <div class="col-8">
            <span style="font-size:16px; font-weight: bold;">Activation Parker(s) spACE accounts.  This may take a few minutes...</span>
        </div>
    </div>
</ng-container>



<ng-container *ngIf="this.parkerActivationList.length > 0 && this.isProcessingNewUsers === false">
    <div style="margin-top:20px;margin-left:10px;height:30px;">
        <span style="font-size:larger;font-weight:400">{{this.parkerActivationList.length}} Parkers found for this Lot Number</span>
    </div>

    <div class="row">
        <div class="col-3">
            <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;width:300px;" (click)="onActivateParkers()" [disabled]="this.numberOfParkersSelected === 0">Activate {{this.numberOfParkersSelected}} Parkers</button>
        </div>
    </div>

<div  class="mat-elevation-z8" style="margin-top:50px; margin-right:20px;height:70vh;" >
    <table   style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;"> 
        <thead style="position:sticky !important;height:30px; overflow-y: auto;top:0px;background-color:gray">
    <tr  class="grid-headers">
        <th  class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:50px">
            <input   style="margin-left:5px;" type="checkbox" id="parkerRowHeader" name="parkerRowHeader" (click)="onToggleCheckAll()">
        </th>
        <th  class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:50px">Lot Number</th>
        <th   class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:350px">Email Address</th>
        <th  class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:150px">Parker Id</th>
        <th   class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:250px">Last Name</th>
        <th   class="invoice-header-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="width:250px">First Name</th>
        
    </tr>
    </thead>
    
    <tr *ngFor="let parker of this.parkerActivationList;let rowIndex = index" 
        style="margin-bottom:20px;background-color:white;" 
        class="grid-rows"
        >
        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            <input type="checkbox" id="parkerRowDetail{{rowIndex}}" name="parkerRowDetail{{rowIndex}}" [checked]="this.parkerActivationList[rowIndex].activateFlag === true"   style="margin-left:5px;" (click)="onCheckParker(parker.parkerId)">
           
                <span *ngIf="parker.result === 1" class="material-icons" style="color:green;padding-top:3px;padding-left:3px;">
                    done
                </span>
                <span *ngIf="parker.result === 2" class="material-icons" style="color:red;padding-top:3px;padding-left:3px;">
                    error
                </span>
        </td>

        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            {{parker.lotNumber}}
        </td>

        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            {{parker.emailAddress}}
        </td>

        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            {{parker.parkerId}}
        </td>

        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            {{parker.lastName}}
        </td>


        <td  class="invoice-cell" [ngStyle]="{'font-size':gridFontSize + 'px'}" style="margin-left:5px;">
            {{parker.firstName}}
        </td>

      
    </tr>
    </table>
</div>
</ng-container>
